import {modals, tags} from "../../ducks";
import {connect} from "react-redux";
import React, {useState} from "react";
import {Formik} from "formik";
import ModalComponent from "../ModalComponent";
import {Button, FormControl, Row} from "react-bootstrap";
import ValidationErrors from "../forms/ValidationErrors";
import PropTypes from "prop-types";


const EditTagModal = ({onClose, onSave, onUnexpectedError, tag = {}}) => {
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  return <Formik
    initialValues={{id: tag.id, name: tag.name || ''}}
    onSubmit={
      values => {
        setLoading(true);
        onSave(values)
          .then(onClose)
          .catch(response => {
            setLoading(false);
            if (response.tag && response.tag.errors) {
              setErrors(response.tag.errors);
            } else {
              onClose();
              onUnexpectedError();
            }
          });
      }
    }>
    {
      ({
         values,
         handleChange,
         handleSubmit
       }) => <ModalComponent
        className="edit-tag-modal"
        title={tag.id ? 'Edit Tag' : 'Add Tag'}
        buttons={[
          <Button type="submit" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </Button>
        ]}>
        <ValidationErrors errors={errors}/>

        <Row>
          <label className="control-label">Tag Name</label>
          <div className="controls">
            <FormControl type="text" name="name" defaultValue={values.name} onChange={handleChange}/>
          </div>
        </Row>
      </ModalComponent>
    }
  </Formik>;
};

EditTagModal.propTypes = {
  tag: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })
};

const mapDispatchToProps = (dispatch) => ({
  onSave: tag => dispatch(tags.actions.save(tag)),
  onClose: () => dispatch(modals.actions.hide()),
  onUnexpectedError: () => dispatch(modals.actions.show('UnexpectedError'))
});

export default connect(null, mapDispatchToProps)(EditTagModal);
